/**
 * Detection Configuration
 * 
 * This file contains feature flags and configuration for ball detection.
 * Modify these values to enable/disable features or tune detection parameters.
 */

export const DETECTION_CONFIG = {
  /**
   * Use Centroid Tracking for Ball Creation
   *
   * When TRUE: Uses industry-standard centroid tracking with persistent blob IDs.
   *   - Prevents motion blur from creating duplicate balls
   *   - No cooldown needed - each blob can only create ONE ball
   *   - More accurate object identity tracking
   *
   * When FALSE: Uses legacy position-based approach with cooldown band-aid.
   *   - Relies on cooldown to prevent duplicates
   *   - May see [COOLDOWN] messages in logs
   *   - Original implementation
   *
   * DEFAULT: false (use legacy approach)
   * RECOMMENDED: false (centroid tracking has issues with fast-moving balls)
   */
  USE_CENTROID_TRACKING: false,
} as const;

